import React, {Component} from 'react';
import {Field} from 'formik';
import {parsers} from '@neosvoc/nv-platform-core-common';

class StringType extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
    }

    validate(value) {
        try {
            parsers.string(value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    render() {
        const {id, required, multiline} = this.props;
        return (
            <div className="form-group">
                {multiline === true ? (
                    <Field name={id} component="textarea" className="form-control" rows="3" validate={this.validate} required={required} />
                ) : (
                    <Field name={id} type="text" className="form-control" validate={this.validate} required={required} />
                )}
            </div>
        );
    }
}

export default StringType;
